// Cost fields nested under `cost.*` in the form (one input per cell in the
// QuoteItemsTable). `comission` is also part of this group — it gets auto-set
// from comissionRate × base by an effect in QuoteItemsTable.
const COST_KEYS = [
  "mold",
  "heatTreat",
  "machining",
  "destructive",
  "xray",
  "certifications",
  "international",
  "other",
  "comission",
];

const DEFAULT_COMMISSION_RATE = 5;

export const getDefaultValues = (data, user, locationId) => ({
  locationId: data?.locationId || locationId,
  // The API returns createdBy as a nested { id, name } from the relation
  // include — the scalar createdById isn't on the response. Fall back through
  // both shapes before defaulting to the current user (new-quote case).
  createdById: data?.createdById ?? data?.createdBy?.id ?? user?.id,
  stage: data?.stage,
  partName: data?.partName || "",
  partNumber: data?.partNumber || "",
  weight: data?.weight ?? 1,
  estimatedAnnualUsage: data?.estimatedAnnualUsage ?? null,
  estimatedScrapRate: data?.estimatedScrapRate ?? 5,
  moldType: data?.moldType ?? 0,
  treeId: data?.treeId || 89,
  partsPerTree: data?.partsPerTree || 1,
  materialId: data?.materialId || 7,
  handBlasting: data?.handBlasting ?? 0,
  flushWitness: data?.flushWitness || 1,
  gates: data?.gates || 1,
  handDipping: data?.handDipping ?? false,
  flashing: data?.flashing ?? false,
  hardToFixture: data?.hardToFixture ?? false,
  weldRepair: data?.weldRepair ?? false,
  fineDetail: data?.fineDetail ?? false,
  straightening: data?.straightening ?? false,
  price: data?.price ?? null,
  cost: Object.fromEntries(COST_KEYS.map((key) => [key, data?.[key] ?? null])),
  comissionRate: data?.comissionRate ?? DEFAULT_COMMISSION_RATE,
  total: data?.total ?? null,
  notes: data?.notes || "",
  customerId: data?.customerId || null,
  leadId: data?.leadId || null,
  partId: data?.partId || null,
  financialPeriodId: data?.financialPeriodId || null,
  partWaxId: data?.partWaxId || 162,
  treeWaxId: data?.treeWaxId || 25,
});

const toNumber = (val) => {
  if (!val && val !== 0) return null;
  const num = Number(val);
  return isNaN(num) ? null : num;
};

export const getUpdatePayload = (formData) => {
  const cost = formData?.cost || {};

  return {
    partName: formData?.partName,
    partNumber: formData?.partNumber,
    weight: toNumber(formData?.weight),
    estimatedAnnualUsage: toNumber(formData?.estimatedAnnualUsage),
    estimatedScrapRate: toNumber(formData?.estimatedScrapRate),
    moldType: toNumber(formData?.moldType) ?? 0,
    treeId: toNumber(formData?.treeId),
    partsPerTree: toNumber(formData?.partsPerTree) || 1,
    materialId: toNumber(formData?.materialId),
    handBlasting: toNumber(formData?.handBlasting) ?? 0,
    flushWitness: toNumber(formData?.flushWitness) ?? 1,
    gates: toNumber(formData?.gates) || 1,
    handDipping: !!formData?.handDipping,
    flashing: !!formData?.flashing,
    hardToFixture: !!formData?.hardToFixture,
    weldRepair: !!formData?.weldRepair,
    fineDetail: !!formData?.fineDetail,
    straightening: !!formData?.straightening,
    price: toNumber(formData?.price || 0),
    ...Object.fromEntries(COST_KEYS.map((key) => [key, toNumber(cost[key])])),
    comissionRate: toNumber(formData?.comissionRate),
    total: toNumber(formData?.total),
    notes: formData?.notes || null,
    customerId: toNumber(formData?.customerId),
    leadId: toNumber(formData?.leadId),
    partId: toNumber(formData?.partId),
    financialPeriodId: toNumber(formData?.financialPeriodId),
    partWaxId: toNumber(formData?.partWaxId),
    treeWaxId: toNumber(formData?.treeWaxId),
    // createdById: toNumber(formData?.createdById),
  };
};

export const tabs = [
  {
    id: 1,
    label: "Costing Sheet",
    icon: "DollarSign",
    showQuote: false,
    showCosting: true,
  },
  {
    id: 2,
    label: "Customer Quote",
    icon: "FileText",
    showCosting: false,
    showQuote: true,
  },
  {
    id: 3,
    label: "Both",
    icon: "Folder",
    showCosting: true,
    showQuote: true,
  },
];
